import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class IpmAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVratedMin = 4.5;
		this.normIoutMin = 11;

		this.rankVratedMin = 0;
		this.rankIoutMin = 0;

		this.weightVratedMin = 0.3;
		this.weightIoutMin = 0.2;

		this.rV = 0;
		this.rI = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_rV,rV,rankVratedMin,part_rI,rI,rankIoutMin,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Rated voltage VRated Min (V)-----------------------------------------------------

		[this.rankVratedMin, this.rV] = this.calculateRankDualSliderGTE(CIDS.RATED_VOLTAGE, product, this.normVratedMin);

		// ---------------------------------------------Output current IOut Min (A)-----------------------------------------------------

		[this.rankIoutMin, this.rI] = this.calculateRankDualSliderGTE(CIDS.OUTPUT_CURRENT, product, this.normIoutMin);

		// --------------------------------------------------------------------------------------------------------------

		let feRank = this.weightVratedMin * this.rankVratedMin + this.weightIoutMin * this.rankIoutMin;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVratedMin - this.weightIoutMin) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
